import React, { useEffect, useState } from 'react'
import { Box, styled, List, ListItem, ListItemText, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';
import Checkoutduespage from './Checkoutduespage';

const StyledTabs = styled(Tabs)({
  backgroundColor: '#e1e7ef',
  borderRadius: '10px',
  padding: '4px',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minHeight: '36px',
  padding: '8px 16px',
  borderRadius: '5px',
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#635bff',
  },
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: '1px solid #e1e7ef',
  padding: '10px 15px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#5BB4D2'
  },
}));

const CheckoutTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = useSelector(selectPermissions);

  const tabs = [
    { 
      label: "Checkout & Handover",
      path: "/checkouttab",
      component: Checkoutduespage,
    },
  ];

  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    navigate(tabs[newValue].path);
  };

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) => tab.path === location.pathname);
    if (currentTabIndex !== -1) {
      setActiveTab(currentTabIndex);
    } else if (tabs.length > 0) {
      setActiveTab(0);
    }
  }, [location.pathname, tabs]);

  const ActiveComponent = tabs[activeTab]?.component;

  return (
    <Box sx={{ 
      width: '100%', 
      p: 2, 
      '& .MuiTabs-root': {
        padding: '7px 4px 0px 4px !important'
      } 
    }}>
      <Box sx={{ mb: 4 }}>
        <StyledTabs 
          value={activeTab} 
          onChange={handleChange} 
          sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
        >
          {tabs.map((tab, index) => (
            <StyledTab key={index} label={tab.label} />
          ))}
        </StyledTabs>

        <Box sx={{ display: { xs: 'block', sm: 'none' }, mt: 2 }}>
          <List>
            {tabs.map((tab, index) => (
              <StyledListItem 
                // button 
                key={index} 
                onClick={() => {
                  navigate(tab.path);
                }}
              >
                <ListItemText primary={tab.label} />
              </StyledListItem>
            ))}
          </List>
        </Box>
      </Box>

      <Box>
        {ActiveComponent && 
          <ActiveComponent permissions={permissions} />
        }
      </Box>
    </Box>
  );
};

export default CheckoutTab;